import React, { useContext, useState } from 'react';
import { Form, Formik } from 'formik';
import * as Yup from 'yup';
import { useDispatch, useSelector } from 'react-redux';

import FormGrid from '../../../Form/FormGrid/FormGrid';
import Button from '../../../Buttons/Button/Button';
import { stringSchema } from '../../../../services/schemas';
import LabelFieldFormik from '../../../Fields/LabelField/LabelFieldFormik';
import { formTypes } from '../../../../store/catalogs/forms';

import classes from './DateIntegration.module.scss';
import moment from 'moment-timezone';
import { setValues } from '../../../../store/slices/UI';
import BackButton from '../../../Buttons/BackButton/BackButton';
import Context from '../../../../store/context';
import AskInvoicesIntegration from '../AskInvoicesIntegration';

const messageFormik = 'Campo obligatorio';
const validationSchema = Yup.object().shape({
  dateIntegration: stringSchema(messageFormik)
});

const DateIntegration = ({ onCallback, dateIntegration, type }) => {
  const [buttonText, setButtonText] = useState('Continuar');

  const { businessId, businesses } = useSelector(state => state.userData);
  const invoicesExtractStartDate = businesses[businessId]?.dianConnections[0]?.invoicesExtractStartDate;

  const {
    modal: { showModal }
  } = useContext(Context);

  const dispatch = useDispatch();

  const fields = {
    array: [
      {
        key: 'dateIntegration',
        type: formTypes.date,
        cols: 2,
        options: {
          min: moment().add(-2, 'years').format('YYYY-MM-DD'),
          max: dateIntegration ? invoicesExtractStartDate : moment().format('YYYY-MM-DD')
        }
      }
    ]
  };

  const valuesDemography = {
    dateIntegration: dateIntegration ? dateIntegration : undefined
  };

  const onAccept = value => {
    setButtonText('Cargando...');
    if (type === 'active') {
      dispatch(setValues({ showBelvoWidget: true, belvoParameters: { integrationStartDate: value.dateIntegration } }));
    } else {
      onCallback(value.dateIntegration);
    }
  };

  const setField = (setFieldValue, key, value) => {
    setFieldValue(key, value);
  };

  const goAskInvoicesIntegration = () => {
    showModal(
      <AskInvoicesIntegration
        title='Activa la sincronización de cuentas de cobro con la DIAN'
description='Traeremos de manera automática tus cuentas de cobro electrónicas y la información más importante de esos proveedores. Solo debes ingresar tus credenciales de la DIAN y después cada 24 horas se te enviará un código para actualizar esta sincronización.'
      />
    );
  };

  return (
    <div className={classes.content}>
      <BackButton onClick={goAskInvoicesIntegration} />
      <div className={classes.head}>
        <span className='semibold-18'>Selecciona el período desde el cual quieres traer las cuentas de cobro</span>
        <span className={`${classes.text} medium-16`}>Puede ser desde hace máximo un año</span>
      </div>
      <Formik initialValues={valuesDemography} validationSchema={validationSchema} onSubmit={onAccept}>
        {({ setFieldValue, isSubmitting }) => (
          <Form className={classes.form}>
            <div className={classes.inputs}>
              <FormGrid
                className={classes.fields}
                onChange={(key, value) => setField(setFieldValue, key, value)}
                fields={fields.array}
                Render={LabelFieldFormik}
              />
            </div>
            <div className={classes.button}>
              <Button custom='primary' type='submit' disabled={isSubmitting}>
                {buttonText}
              </Button>
            </div>
          </Form>
        )}
      </Formik>
    </div>
  );
};

export default DateIntegration;
